import type { operations } from "@/shared/api/generated/openapi";

import { addDays } from "./addDays";
import { DURATION_BUCKETS } from "./DURATION_BUCKETS";
import { MANY_DEATHS } from "./MANY_DEATHS";
import type { MatchFilters } from "./matchFiltersSchema";
import { periodRange } from "./periodRange";

export type MatchQuery = NonNullable<operations["list_matches"]["parameters"]["query"]>;

// Фильтры из URL главной → query-параметры `GET /api/matches`: фильтрует бэкенд, по всей
// истории. Период — границы дней в часовом поясе браузера; в течение дня они те же, поэтому
// ключ запроса не меняется на каждой перерисовке. Выключенный фильтр — параметра нет.
export const toMatchQuery = (filters: MatchFilters, now: Date): MatchQuery => {
  const query: MatchQuery = {};
  if (filters.mode !== undefined) {
    query.mode = filters.mode;
  }
  if (filters.result !== undefined) {
    query.result = filters.result;
  }
  if (filters.heroes !== undefined && filters.heroes.length > 0) {
    query.heroes = filters.heroes;
  }
  const range = periodRange(filters, now);
  if (range !== null) {
    query.started_from = range.from.toISOString();
    query.started_to = addDays(range.to, 1).toISOString();
  }
  if (filters.analyzed !== undefined) {
    query.analyzed = filters.analyzed === "yes";
  }
  if (filters.duration !== undefined) {
    const [min, max] = DURATION_BUCKETS[filters.duration];
    query.min_duration_s = min;
    if (Number.isFinite(max)) {
      query.max_duration_s = max;
    }
  }
  if (filters.deaths !== undefined) {
    query.min_deaths = MANY_DEATHS;
  }
  if (filters.place !== undefined) {
    query.place = filters.place;
  }
  return query;
};
